import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import css from './SetPlan.module.scss';
import BackButton from '../../../components/UI/BackButton';
import { AnalyticsContext } from '../../../context/analytics';
import { Plan } from '.';
import Button from '../../../components/UI/Button';
import { PlanInfo } from './ChecklistsAndContent/content';

interface Props {
  onBackClicked: () => void;
  onUpgradeClicked: () => void;
  plan: Plan;
  loading: boolean;
  analytics: any;
}

const LocationSharingLearnMore = ({
  onBackClicked,
  onUpgradeClicked,
  plan,
  loading,
  analytics
}: Props) => {
  useEffect(() => {
    analytics.trackEvent('Registration Invest Plan Info Viewed', {
      eventProps: {
        plan: 'infinity',
        limitedInfo: true
      }
    });
  }, []);

  return (
    <>
      <BackButton onClick={onBackClicked} />
      <div className={css.familyLocationSharingContainer}>
        <h1
          className={css.familyLocationSharingHeader}
          data-e2e="family-location-sharing-info-header"
        >
          Family Location Sharing&dagger;
        </h1>

        <div className={css.familyLocationSharingImageContainer}>
          <img
            className={css.familyLocationSharingImage}
            data-e2e="family-location-sharing-image"
            src={'/static/family-location-sharing.png'}
            alt="Family location sharing example"
          />
        </div>

        <h1 data-e2e="family-location-sharing-subheader">How it works</h1>

        <p data-e2e="family-location-sharing-p1">
          See the current location of your family members and choose who sees
          your location.
        </p>
        <p data-e2e="family-location-sharing-p2">
          Reach out to family members when checking their locations by sending
          messages and calling.
        </p>

        <Button
          text={`Upgrade to Greenlight ${PlanInfo[plan].planName}`}
          loading={loading}
          onClick={onUpgradeClicked}
          data-e2e="family-location-sharing-upgrade-button"
        />

        <p className={css.investSecondaryButton} onClick={onBackClicked}>
          Go back
        </p>

        <div className={css.familyLocationSharingFooter}>
          <p>
            &dagger;Requires mobile data or a WiFi connection, and access to
            sensory and motion data from cell phone to utilize family location
            sharing, SOS alerts and crash detection features. Messaging and data
            rates and other terms may apply.
          </p>
          <p>
            By choosing to upgrade, you are accepting Greenlight&apos;s Terms of
            Service &amp; Privacy Statement.
          </p>
        </div>
      </div>
    </>
  );
};

export default LocationSharingLearnMore;
